<template>
  <div :class="{
          'app': type === 'application',
          'empty': !documents.length,
        }"
       class="documents-list">
    <div v-for="document in documents" :key="document.guid" :class="{ 'single': documents.length === 1 }" class="document">
      <div class="document__icon">
        <img src="../assets/images/document.svg" alt="document icon">
      </div>
      <div class="document__body">
        <div class="document__title">
          <a :href="getLink(document)" target="_blank" v-text="document.title"></a>
        </div>
        <div class="document__description" v-text="document.description"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentList",
  props: {
    documents: Array,
    /*
    * Тип выводимых документов. Используется для применения стилей.
    */
    type: String
  },
  methods: {
    getLink(doc) {
      // eslint-disable-next-line
      return `${__config.base_url}/docs/${doc.guid}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.documents-list {
  padding-top: 50px;
  display: flex;
  flex-wrap: wrap;

  &.app {
    background-color: #f5f5f5;
    padding-left: 40px;
  }

  .document {
    position: relative;
    width: 50%;
    display: flex;
    margin-bottom: 40px;
    padding-right: 50px;

    &.single {
      width: 70%;
      @include media-breakpoint-down(sm) {
        width: 100%;
      }
    }
  }
  .document__icon {
    margin-right: 37px;
  }
  .document__title {
    padding-bottom: 15px;
    font-size: 20px;
    line-height: 23px;
    text-align: left;
    font-weight: 500;

    a {
      color: #000;
      text-decoration: none;
    }
  }
  .document__description {
    font-size: 13px;
    line-height: 15px;
    color: #9c9a9a;

    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.app {
  .document__title {
    padding-bottom: 10px;
  }
}
@include media-breakpoint-down(md) {
  .documents-list {
    .document {
      width: 100%;
      padding-right: 0;
    }
  }
}

@include media-breakpoint-down(sm) {
  .documents-list {
    .document__icon {
      position: absolute;
      top: 5px;
    }
    .document__title {
      margin-left: 60px;
      min-height: 65px;
      font-size: 18px;
    }
    .document__description {
      margin-top: 10px;
    }

    &.app {
      padding-left: 10px;
      padding-right: 10px;

      .document__description {
        margin-top: 0;
        margin-left: 60px;
      }
    }
  }
}
</style>
